import React, { useState } from 'react';
import { ActivityIndicator, Button, Dropdown, Icon, useMediaQueryContext, } from '@fourthwall/components';
import { FilterIcon } from '@fourthwall/icons';
import { AnalyticsFiltersSelect } from '../AnalyticsFilterSelect/AnalyticsFiltersSelect';
import * as S from './AnalyticsFiltersButton.styled';
export const AnalyticsFiltersButton = ({ filters, isActive, onChange, }) => {
    const media = useMediaQueryContext();
    const [isOpen, setOpen] = useState(false);
    if (!filters.length)
        return null;
    return (React.createElement(Dropdown, { isOpen: isOpen, content: React.createElement(AnalyticsFiltersSelect, { filters: filters, onChange: onChange }), position: "bottom-end", maxWidth: 500, onClose: () => setOpen(false) },
        React.createElement(S.Container, null,
            React.createElement(Button, { leftIcon: React.createElement(Icon, { component: FilterIcon, height: 18 }), label: "Filters", appearance: "secondary", size: media.tablet ? 'medium' : 'small', onClick: () => setOpen((status) => !status) }),
            isActive && (React.createElement(S.ActivityIndicatorWrapper, null,
                React.createElement(ActivityIndicator, null))))));
};
